module.exports = __webpack_public_path__ + "img/1970East-011_WEB-min.98c0ad45.jpg";